module.exports = __webpack_public_path__ + "static/media/pain-overview.47e61f15.png";